// File: src/context/SocketProvider.jsx
import React, {
  createContext,
  useContext,
  useMemo,
} from "react";

/**
 * SocketProvider
 *
 * Current status:
 * - no realtime transport is enabled
 * - no JWT/localStorage authentication is used
 * - keeps existing socket consumers stable
 *
 * IMPORTANT:
 * When realtime support is introduced later, socket authentication
 * should use the server-controlled session architecture rather than
 * restoring browser-readable JWT authority.
 */

const DEFAULT_SOCKET_STATE = Object.freeze({
  socket: null,
  connected: false,
  connecting: false,
  error: null,
});

const SocketContext =
  createContext(DEFAULT_SOCKET_STATE);

export function SocketProvider({
  children,
}) {
  const value =
    useMemo(
      () => ({
        socket: null,
        connected: false,
        connecting: false,
        error: null,
      }),
      []
    );

  return (
    <SocketContext.Provider
      value={value}
    >
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(
    SocketContext
  );
}